import styled from 'styled-components';
import Screen from '../../../../shared/utils/screen';
import withAnimation from '@shared/components/utils/hoc/withAnimation';

const ChannelListArrowLeftContainer = styled.div<React.CSSProperties>`
  position: fixed;
  top: ${523 * Screen.widthRatio}px;
  left: ${100 * Screen.widthRatio}px;
`;

export default withAnimation(ChannelListArrowLeftContainer);
